import {useEffect, useState} from 'react';

import {getAiReviewUsageDetail} from 'src/openapi/apis/ChangeRequestAiUsageControllerApi';
import {AiReviewUsageDetailedInfo} from 'src/openapi/models/AiReviewUsageDetailedInfo';
import {useAppDispatch} from 'src/store';

import {Icons} from '@pb/kit-component-icon';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

export const useAiReviewUsageDetail = (changeRequestId: number) => {
    const dispatch = useAppDispatch();
    const {onCreateNote} = usePushNotification();
    const [isLoading, setIsLoading] = useState(false);
    const [assistDetails, setAssistDetails] = useState<AiReviewUsageDetailedInfo[]>([]);

    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
            const response = await dispatch(getAiReviewUsageDetail({changeRequestId}));

            if (response.payload?.success) {
                setAssistDetails(response.payload.data);
            }

            if (response.payload?.error) {
                onCreateNote({
                    id: 'getAiReviewUsageDetailError',
                    status: Status.ERROR,
                    message: response.payload.data?.message,
                    buttonProps: {iconProps: {type: Icons.CLOSE}},
                    autoHideTimeout: 10000,
                });
            }

            setIsLoading(false);
        };

        fetchData();
    }, [changeRequestId, dispatch, onCreateNote]);

    return {assistDetails, isLoading};
};
